import React, { useState, useCallback, useEffect } from 'react';
import Select, { components } from 'react-select';

const MenuList = (props) => {
     return (
          <components.MenuList {...props} className={`${!Array.isArray(props.children) ? 'no-options' : ''}`}>
               {props.children}
          </components.MenuList>
     );
};

const LazyLoadSelect = (props) => {
     const {
          id,
          name,
          label,
          placeholder,
          value,
          isMulti,
          isDisabled,
          isClearable,
          backspaceRemovesValue,
          noOptionsMessage,
          setErrors,
          className,
          error,
          touched,
          options: initOptions = [],
     } = props;
     const pageSize = 100;

     const [page, setPage] = useState(1);
     const [searchQuery, setSearchQuery] = useState('');
     const [filteredOptions, setFilteredOptions] = useState(initOptions);
     const [hasMore, setHasMore] = useState(initOptions.length > pageSize);
     const [options, setOptions] = useState(initOptions.slice(0, pageSize));
     const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

     useEffect(() => {
          const filtered = searchQuery ? initOptions.filter((option) => option.label.toLowerCase().includes(searchQuery.toLowerCase())) : initOptions;

          setFilteredOptions(filtered);
          setPage(1);
          setOptions(filtered.slice(0, pageSize));
          setHasMore(filtered.length > pageSize);
     }, [searchQuery, initOptions]);

     const fetchMoreOptions = useCallback(() => {
          if (!hasMore) return;

          const start = page * pageSize;
          const end = start + pageSize;
          const moreOptions = filteredOptions.slice(start, end);

          setOptions((prevOptions) => [...prevOptions, ...moreOptions]);
          setPage((prevPage) => prevPage + 1);

          if (end >= filteredOptions.length) setHasMore(false);
     }, [hasMore, page, filteredOptions]);

     const handleMenuScrollToBottom = () => {
          fetchMoreOptions();
     };

     const handleInputChange = (inputValue) => {
          setSearchQuery(inputValue);
     };

     return (
          <div className={`input-field-wrapper select-field-custom ${className}`}>
               {label && (
                    <label className='input-label' htmlFor={name} error={error}>
                         {label}
                    </label>
               )}

               <Select
                    classNamePrefix='react-select'
                    className={`text-dark ${className}`}
                    id={id}
                    placeholder={defaultPlaceholder}
                    options={options}
                    value={value}
                    onChange={(selectedOption) => {
                         props.onChange(name, selectedOption);
                         if (error) setErrors({});
                    }}
                    onBlur={() => {
                         if (props.onBlur) props.onBlur(name, true);
                    }}
                    touched={touched}
                    error={error}
                    isMulti={isMulti}
                    isDisabled={isDisabled}
                    isClearable={isClearable}
                    backspaceRemovesValue={backspaceRemovesValue}
                    components={{ ClearIndicator: null, MenuList }}
                    noOptionsMessage={noOptionsMessage}
                    isSearchable={defaultPlaceholder === placeholder ? false : true}
                    onMenuOpen={() => setDefaultPlaceholder('Type here to filter the list…')}
                    onMenuClose={() => setDefaultPlaceholder(placeholder)}
                    onInputChange={handleInputChange}
                    onMenuScrollToBottom={handleMenuScrollToBottom}
               />
               {touched && error ? <p style={{ color: '#e55353', fontSize: '80%' }}>{error}</p> : null}
          </div>
     );
};

export default LazyLoadSelect;
